"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LexusButtonVariants = exports.GazooRacingThemeTuple = void 0;
const LexusButtonVariants = exports.LexusButtonVariants = {
  default: "default",
  PrimaryBlack: "PrimaryBlack",
  PrimaryWhite: "PrimaryWhite",
  BespokeBlack: "BespokeBlack",
  BespokeWhite: "BespokeWhite",
  SecondaryBlack: "SecondaryBlack",
  SecondaryWhite: "SecondaryWhite",
  PrimaryGold: "PrimaryGold",
  SecondaryGold: "SecondaryGold",
  ToyotaRed: "ToyotaRed",
  ToyotaBlack: "ToyotaBlack",
  ToyotaWhite: "ToyotaWhite",
  SSBackBtn: "SSBackBtn",
  SSNextBtn: "SSNextBtn",
  SSRedBtn: "SSRedBtn",
  TimeButton: "TimeButton",
  LexusTimeButton: "LexusTimeButton",
  ToyotaSSTTransparent: "ToyotaSSTTransparent",
  ToyotaSSTSetPreferredVehicle: "ToyotaSSTSetPreferredVehicle",
  MyLexusTransparent: "MyLexusTransparent",
  GRPrimaryRed: "GRPrimaryRed",
  GRSecondaryRed: "GRSecondaryRed",
  GRPrimaryBlack: "GRPrimaryBlack",
  GRPrimaryWhite: "GRPrimaryWhite"
};
const GazooRacingThemeTuple = exports.GazooRacingThemeTuple = [LexusButtonVariants.GRPrimaryRed, LexusButtonVariants.GRSecondaryRed, LexusButtonVariants.GRPrimaryBlack, LexusButtonVariants.GRPrimaryWhite];